//@ts-nocheck
'use client'

import { postMethod, getTheStatusOfRecruiterAlreadyPostedAJob, getMethod } from '@/utils/functions'
import {
  OTP_GENERATE_ENDPOINT,
  OTP_VERIFY_ENDPOINT,
  OTP_RESEND_ENDPOINT,
  ADVERTISER_PROFILE_DETAILS
} from '@/constants/all'

import { useContext, useState, useRef, useEffect } from 'react'
import { motion, useInView, useAnimation } from 'framer-motion'

import Image from 'next/image'
import BANNER from '/public/hire/banner.webp'
import steps from '/public/hire/footprint.webp'
import Groups from '/public/hire/groups.webp'
import location from '/public/hire/location.webp'
import rightarrow from '/public/hire/rightarrow.webp'
import work from '/public/hire/work.webp'
import { trackEvent } from '../../analytics'
import { advertiserAnalyticOptions } from '@/utils/functions'
import { isMobile } from '@/lib/utils'
import { useRouterHook } from '../../hooks/useRouterHook'
import { loginTrack } from '../../analytics'
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '@/components/ui/card'

import { InputOTP, InputOTPGroup, InputOTPSlot } from '@/components/ui/input-otp'

import { useFormik } from 'formik'
import * as Yup from 'yup'

import { Input } from '@/components/ui/input'

import { Icons } from '@/components/hire/icons'
import { cn } from '@/lib/utils'

import { Check } from 'lucide-react'

import { Timer } from '@/components/Timer'
import useTranslation from '@/hooks/useTranslation'
import Link from 'next/link'
import { SharedContext } from '@/context/SharedContext'
import { AdvertiserContext } from '@/context/AdvertiserContext'
import FieldInput from '@/commonComponents/seeker/FieldInput'
import { useRouter } from 'next/router'
import LockIcon from '@mui/icons-material/Lock'

const mobileRegex = /^[6-9]\d{9}$/ // 10-digit Indian mobile

interface BannerProps {
  utm: URLSearchParams
}
export default function Banner({ utm }: BannerProps) {
  const { navigateToPagesInAdvertiser } = useRouterHook()

  const { cookie, setLoginDetails, setUtmParams, utmParams } = useContext(SharedContext)

  const {
    enterpriseLoginDetails,
    setEnterpriseLoginDetails,
    advertiserProfileDetails,
    setAdvertiserProfileDetails
  } = useContext(AdvertiserContext)

  const [lang, setLang] = useState<string[]>([])
  const [loading, setLoading] = useState(false)
  const [mobile_no, setMobile_no] = useState('')
  const [resendEnable, setResendEnble] = useState(false)
  // const [mobilenoform, setMobilenoForm] = useState(true)
  const [otpform, setotpform] = useState(false)
  const [otpRequestCount, setOtpRequestCount] = useState(0)

  const onTimerComplete = () => {
    setResendEnble(true)
  }

  const [isOpen, setOpen] = useState(false)

  const [apiError, setApiError] = useState(null)
  const [OnSuccess, setOnSuccess] = useState(false)

  // const formik_login = useFormik({
  //   enableReinitialize: true,
  //   initialValues: {
  //     mobile_no: '',
  //     i_agree_check: true
  //   },
  //   validationSchema: Yup.object({
  //     mobile_no: Yup.string()
  //       .matches(
  //         /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
  //         'Invalid phone number. Please try again.'
  //       )
  //       .min(10, 'Invalid phone number. Please try again.')
  //       .max(10, 'Invalid phone number. Please try again.')
  //       .required('Phone number is required.'),
  //     i_agree_check: Yup.bool() // use bool instead of boolean
  //       .oneOf([true], 'You must accept the terms and conditions')
  //   }),
  //   validate: (values) => {},
  //   onSubmit: async (values) => {
  //     // alert(JSON.stringify(values, null, 2))
  //     setLoading(true)

  //     const res = await postMethod({
  //       url: process.env.NEXT_PUBLIC_BASE_URL_API + OTP_GENERATE_ENDPOINT,
  //       data: { mobile_no: values.mobile_no }
  //     })
  //     if (res?.['message'] == 'otp generated') {
  //       setLoading(false)
  //       setotpform(true)
  //       trackEvent({
  //         name: 'otp_sent_successfully',
  //         searchParams: utmParams || {},
  //         options: {
  //           ...advertiserAnalyticOptions({
  //             enterprise: !!enterpriseLoginDetails?.advertiserId,
  //             category: 'trigger'
  //           }),
  //           device_type: isMobile() ? 'mobile' : 'web',
  //           label: 'landing_page',
  //           mobileNumber: mobile_no
  //         }
  //       })
  //       trackEvent({
  //         name: 'viewed_otp_screen',
  //         searchParams: utmParams || {},
  //         options: {
  //           ...advertiserAnalyticOptions({
  //             enterprise: !!enterpriseLoginDetails?.advertiserId,
  //             category: 'impression'
  //           }),
  //           device_type: isMobile() ? 'mobile' : 'web',
  //           label: 'landing_page',
  //           mobileNumber: mobile_no
  //         }
  //       })

  //       setOnSuccess(false)
  //     } else {
  //       trackEvent({
  //         name: 'otp_send_failure',
  //         searchParams: utmParams || {},
  //         options: {
  //           ...advertiserAnalyticOptions({
  //             enterprise: !!enterpriseLoginDetails?.advertiserId,
  //             category: 'trigger'
  //           }),
  //           device_type: isMobile() ? 'mobile' : 'web',
  //           label: 'landing_page',
  //           mobileNumber: mobile_no
  //         }
  //       })

  //       setLoading(false)
  //       setApiError(res.message)
  //     }
  //   }
  // })

  // const formik_verify = useFormik({
  //   enableReinitialize: true,
  //   initialValues: {
  //     otp: '',
  //     mobile_no,
  //     wa_optin: 1
  //   },
  //   validationSchema: Yup.object({
  //     otp: Yup.string().min(4, 'Please enter a valid OTP').required('Please enter a valid OTP'),
  //     mobile_no: Yup.string()
  //       .matches(
  //         /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
  //         'Invalid phone number. Please try again.'
  //       )
  //       .min(10, 'Invalid phone number. Please try again.')
  //       .max(10, 'Invalid phone number. Please try again.')
  //       .required('Phone number is required.')
  //   }),
  //   validate: (values) => {},
  //   onSubmit: async (values) => {
  //     // alert(JSON.stringify(values, null, 2))
  //     setLoading(true)

  //     const otpRes = await postMethod({
  //       url: process.env.NEXT_PUBLIC_BASE_URL_API + OTP_VERIFY_ENDPOINT,
  //       data: {
  //         mobile_no: values.mobile_no,
  //         otp: values.otp,
  //         wa_optin: values.wa_optin,
  //         utm_source: utm.get('utm_source') || '',
  //         utm_campaign: utm.get('utm_campaign') || '',
  //         utm_medium: utm.get('utm_medium') || ''
  //       }
  //     })
  //     /* if (otpRes?.id) return { isLogedIn: true, data: otpRes }
  // 	else return { isLogedIn: false, msg: otpRes?.message } */
  //     if (otpRes?.id) {
  //       setLoading(false)
  //       if (otpRes?.advertiser_id || otpRes?.enterprise_adveriser_id) {
  //         setEnterpriseLoginDetails((prv: any) => ({
  //           ...prv,
  //           advertiserId: otpRes?.advertiser_id || otpRes?.enterprise_adveriser_id,
  //           companyName: otpRes?.data?.company_name,
  //           email: otpRes?.data?.email,
  //           companyAddress: otpRes?.data?.company_address,
  //           name: otpRes?.data?.name
  //         }))
  //       }
  //       setLoginDetails((prv: any) => ({
  //         ...prv,
  //         mobileNumber: values.mobile_no,
  //         isLogIn: true,
  //         id: otpRes?.id
  //       }))
  //       cookie.set('user', otpRes?.id, { path: '/' })
  //       // api to get advertiser details
  //       const advertiserDetails = await getMethod({
  //         url: process.env.NEXT_PUBLIC_BASE_URL_ADS + ADVERTISER_PROFILE_DETAILS
  //       })
  //       if (advertiserDetails?.id) {
  //         setAdvertiserProfileDetails((prv: any) => ({
  //           ...prv,
  //           advertiserId: advertiserDetails?.id || advertiserDetails?.enterprise_adveriser_id,
  //           companyName: advertiserDetails?.title,
  //           email: advertiserDetails?.email_id,
  //           companyAddress: advertiserDetails?.address,
  //           name: advertiserDetails?.contact_person,
  //           mobileNumber: advertiserDetails?.mobile_no
  //         }))
  //       }
  //       const response = await getTheStatusOfRecruiterAlreadyPostedAJob()
  //       let status = response?.status || false
  //       trackEvent({
  //         name: 'login_successful',
  //         searchParams: utmParams || {},
  //         options: {
  //           ...advertiserAnalyticOptions({
  //             enterprise: !!enterpriseLoginDetails?.advertiserId,
  //             category: 'conversion'
  //           }),
  //           device_type: isMobile() ? 'mobile' : 'web',
  //           label: 'landing_page',
  //           user_tenure_flag: status ? 'new' : 'repeat'
  //         }
  //       })
  //       trackEvent({
  //         name: 'otp_verification_successful',
  //         searchParams: utmParams,
  //         options: {
  //           lokal_user_id: otpRes?.id || '',
  //           user_type: otpRes?.advertiser_id ? 'b2b' : 'b2c',
  //           mobile_number: values?.mobile_no || ''
  //         }
  //       })
  //       loginTrack({ id: otpRes?.id || '', mobileNumber: values?.mobile_no })
  //       setIsFirstTimeAdvertiser(status)
  //     } else {
  //       setLoading(false)
  //       trackEvent({
  //         name: 'incorrect_otp',
  //         searchParams: utmParams || {},
  //         options: {
  //           ...advertiserAnalyticOptions({
  //             enterprise: !!enterpriseLoginDetails?.advertiserId,
  //             category: 'tap'
  //           }),
  //           device_type: isMobile() ? 'mobile' : 'web',
  //           label: 'landing_page'
  //         }
  //       })
  //       setApiError(otpRes?.message) // from /advertisers/v1/profile/me only, key yet to know
  //     }
  //   }
  // })

  // useEffect(() => {
  //   if (otpform) {
  //     try {
  //       const ac = new AbortController()
  //       setTimeout(() => {
  //         ac.abort()
  //       }, 10 * 60 * 1000)
  //       navigator.credentials
  //         .get({
  //           otp: { transport: ['sms'] },
  //           signal: ac.signal
  //         })
  //         .then((otpCredential) => {
  //           if (otpCredential && otpCredential.code) {
  //             const otpCode = otpCredential.code.trim()
  //             formik_verify.setFieldValue('otp', otpCode)
  //           }
  //         })
  //         .catch((err) => {
  //           console.log('Error retrieving OTP:', err)
  //         })
  //     } catch (err) {
  //       console.log('Web OTP API not supported:', err)
  //     }
  //   }
  // }, [otpform, otpRequestCount])

  const ref = useRef(null)
  const isInView = useInView(ref, { once: true })
  const cardControl = useAnimation()
  useEffect(() => {
    if (isInView) {
      cardControl.start('visible')
    }
  }, [isInView])

  useEffect(() => {
    setUtmParams(JSON.stringify(utm))
  }, [])

  return (
    <section
      id="banner-section"
      className="custom-mb-margin relative h-screen min-w-full md:mb-[0px]"
    >
      <div className="bannerbox">
        <Image
          src={BANNER}
          className={'bannerbox-img h-[80vh] sm:h-screen'}
          width={0}
          height={0}
          alt={''}
          priority
        />
        <div className="customPadding absolute z-10 px-[16px] md:px-[40px] lg:px-[80px]">
          <div className="mobilegap-360 grid grid-cols-1 items-center gap-x-[0px] gap-y-[30px] md:grid-cols-2 md:gap-x-[25px] md:gap-y-[0px] lg:gap-x-[103px]">
            <motion.h1
              variants={{ hidden: { opacity: 0, y: 95 }, visible: { opacity: 1, y: 0 } }}
              transition={{ duration: 0.8 }}
              initial={'hidden'}
              animate={'visible'}
              className="bannertitle col-span-1"
            >
              Find professional and skilled candidates
            </motion.h1>
            <motion.div
              variants={{
                hidden: { opacity: 0, y: 95 },
                visible: { opacity: 1, y: 0 }
              }}
              transition={{ duration: 0.8 }}
              initial={'hidden'}
              animate={'visible'}
            >
              <Card
                className={cn(
                  'col-span-1 rounded-[12px] border-none p-[24px] shadow-none md:rounded-[16px] md:px-[40px] md:py-[32px]'
                )}
              >
                <LoginCard />
              </Card>
            </motion.div>
          </div>
        </div>
        <div
          className={
            'for360 absolute bottom-[-55px] z-10 translate-y-[112px] md:bottom-[0px] md:translate-y-[40px]'
          }
        >
          <div className={'subContainer md:subContainerDesk'}>
            <motion.div
              ref={ref}
              variants={{
                hidden: { opacity: 0, y: 95 },
                visible: { opacity: 1, y: 0 }
              }}
              transition={{ duration: 0.3 * 1, delay: 0.2 }}
              initial={'hidden'}
              animate={cardControl}
              className={'whiteBox'}
            >
              <div className={'whiteBoxInner'}>
                <Image
                  src={steps}
                  className={'h-[20px] w-auto md:h-[24px]'}
                  width={0}
                  height={0}
                  alt={''}
                />
              </div>
              <p className="mb-[0px]">
                3 <br />
                easy steps
              </p>
            </motion.div>
            <motion.div
              ref={ref}
              variants={{
                hidden: { opacity: 0, y: 95 },
                visible: { opacity: 1, y: 0 }
              }}
              transition={{ duration: 0.3 * 2, delay: 0.2 }}
              initial={'hidden'}
              animate={cardControl}
              className={'whiteBox'}
            >
              <div className={'whiteBoxInner bg-[#E5E6FF] '}>
                <Image
                  src={Groups}
                  className={'h-[20px] w-auto md:h-[24px]'}
                  width={0}
                  height={0}
                  alt={''}
                />
              </div>
              <p className="mb-[0px]">
                {' '}
                25 lakh+ <br />
                candidates
              </p>
            </motion.div>
            <motion.div
              ref={ref}
              variants={{
                hidden: { opacity: 0, y: 95 },
                visible: { opacity: 1, y: 0 }
              }}
              transition={{ duration: 0.3 * 3, delay: 0.2 }}
              initial={'hidden'}
              animate={cardControl}
              className={'whiteBox'}
            >
              <div className={'whiteBoxInner bg-[#ffeee5] '}>
                <Image
                  src={location}
                  className={'h-[20px] w-auto md:h-[24px]'}
                  width={0}
                  height={0}
                  alt={''}
                />
              </div>
              <p className="mb-[0px]">
                250+ <br />
                districts
              </p>
            </motion.div>
            <motion.div
              ref={ref}
              variants={{
                hidden: { opacity: 0, y: 95 },
                visible: { opacity: 1, y: 0 }
              }}
              transition={{ duration: 0.3 * 4, delay: 0.2 }}
              initial={'hidden'}
              animate={cardControl}
              className={'whiteBox'}
            >
              <div className={'whiteBoxInner bg-[#E7F3FE]'}>
                <Image
                  src={work}
                  className={'h-[20px] w-auto md:h-[24px]'}
                  width={0}
                  height={0}
                  alt={''}
                />
              </div>
              <p className="mb-[0px]">
                15,000+
                <br />
                recruiters
              </p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  )
}

const LoginCard = () => {
  const router = useRouter()
  const { navigateToPagesInAdvertiser } = useRouterHook()

  /* local state */
  const [mobile, setMobile] = useState('')
  const [error, setError] = useState('')
  const [touched, setTouched] = useState(false)

  /* ------------ validation ------------ */
  const validate = (num: string) => {
    if (!num) return 'Please enter mobile number'
    if (!mobileRegex.test(num)) return 'Enter a valid 10-digit mobile number'
    return ''
  }

  /* ------------ handlers -------------- */
  const handleOtpLogin = () => {
    setTouched(true)
    const err = validate(mobile)
    setError(err)
    if (err) return

				const qs = `stage=otp&mobile=${mobile}`;
    navigateToPagesInAdvertiser({
      pathName: 'advertiserSignIn',
      as: `signin?${qs}`,
      query: { stage: 'otp', mobile: mobile }
    })
  }

  const handlePwdLogin = () => {
    setTouched(true)
    const err = validate(mobile)
    setError(err)
    if (err) return

				const qs = `stage=password&mobile=${mobile}`;
    navigateToPagesInAdvertiser({
      pathName: 'advertiserSignIn',
      as: `signin?${qs}`,
      query: { stage: 'password', mobile: mobile }
    })
  }

  /* ------------ UI -------------------- */
  return (
    <div className="space-y-[15px] md:space-y-[24px]">
      {/* header */}
      <CardHeader className={cn('p-0 mb-[-14px] font-medium')}>
        <CardTitle
          className={cn(
            'notoSansBold text-[18px] leading-[28px] tracking-[0.2px] text-title md:text-[28px]'
          )}
        >
          Employer Login/ Signup
        </CardTitle>
      </CardHeader>

      {/* mobile input */}
      <CardContent className="p-0 grid gap-6 gap-y-[8px]">
        <div className="flex items-start gap-x-[12px]">
          <div className="flex w-full flex-col gap-3">
            <div className="text-md font-normal leading-24 text-title">Mobile Number</div>

            <FieldInput
              id="home-mobile"
              title="Enter 10 digit mobile number"
              maxLength={10}
              value={mobile}
              onChange={(_, v) => {
                const val = v.replace(/\D/g, '')
                setMobile(val)

                if (touched) {
                  const e = validate(val)
                  setError(e)
                }
              }}
              isErrorPresent={!!error}
              errorTitle={error}
            />
          </div>
        </div>
      </CardContent>

      {/* buttons */}
      <CardFooter className="flex flex-col gap-6">
        <div className="flex w-full flex-col gap-4">
          <button type="button" onClick={handleOtpLogin} className="btn cursor-pointer">
            Login with OTP
          </button>

          <div id="login_with_password_option" className="flex items-center justify-center gap-1">
            <LockIcon className="h-4 w-4 text-title" />

            <div
              className="cursor-pointer text-base leading-20 text-title underline decoration-[auto] decoration-solid"
              onClick={handlePwdLogin}
            >
              Login with password
            </div>
          </div>
        </div>

        <div id="divider" className="h-[1px] w-full bg-[#e5e5e5]" />

        <div className="flex items-center justify-center gap-3">
          <div className="notoSansBold w-max rounded-[4px] bg-textLevel px-[8px] py-[4px] text-[14px] leading-[20px] text-white">
            NEW
          </div>
          <div className={'flex items-center gap-1'}>
            <Link
              scroll={false}
              href={'#query-section'}
              className={
                'notoSansBold mb-[0px] cursor-pointer text-[14px] leading-[20px] text-borderRing no-underline hover:underline hover:decoration-borderRing'
              }
            >
              Try Enterprise solutions
            </Link>
            <Image src={rightarrow} className={'h-[14px] w-auto'} width={0} height={0} alt={''} />
          </div>
        </div>
      </CardFooter>
    </div>
  )
}
